<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
        :additionalSaveFunction="formatAmountBeforeSave"
        :useAdditionalSaveFunction="true"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_BUDGET_GROUP')" 
                        :items="budgetGroupItems" 
                        :context="context"
                        field="BudgetGroup"
                        :alvqa="alvqa + '-dropdown-budget-group'"
                        rules="required"
                        :withMargin="false"
                        :clearable="false"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="ScheduledMonth"
                        :label="$t('lang_LABEL_RELEASES_CAPTION_SCHEDULE_MONTH')"
                        rules="required"
                        :withMargin="false"
                        :alvqa="alvqa + '-datepicker-scheduled-month'"
                        type="month"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Amount"
                        :label="$t('lang_GENERIC_CAPTION_AMOUNT')"
                        :withMargin="false"
                        rules="required"
                        :alvqa="alvqa + '-textfield-amount'"
                        :suffix="$store.getters.getSelectedCurrency"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Description"
                        :label="$t('lang_LABEL_RELEASES_CAPTION_DESCRIPTION')"
                        :withMargin="false"
                        :alvqa="alvqa + '-textfield-description'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageDropdown 
                        :label="$t('lang_GENERAL_CAPTION_COUNTRY')" 
                        :items="countryItems" 
                        :context="context"
                        field="Country"
                        :alvqa="alvqa + '-dropdown-country'"
                        :withMargin="false"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Quantity"
                        :label="$t('lang_LABEL_RELEASES_CAPTION_QUANTITY')"
                        :withMargin="false"
                        :alvqa="alvqa + '-textfield-quantity'"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import { DropdownLabelReleasesBudgetGroupTypes } from '@/assets/dropdowns/alvDropdowns.js'

import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'

export default {
    name: "ReleasesBudgetEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageDropdown,
        BaseEditPageTextField,
        BaseEditPageDatePicker
    },
    data() {
        return {
            context: 'ReleasesBudget',
            alvqa: "label-releases-edit-form-panel-budget-editing-dialog"
        }
    },
    computed: {
        budgetGroupItems() {
            let types = JSON.parse(JSON.stringify(DropdownLabelReleasesBudgetGroupTypes))

            types.forEach(element => {
                if(element.group === 'income') element.text = this.$t('lang_GENERIC_CAPTION_INCOME') + ': ' + this.$t(element.text)
                if(element.group === 'costs') element.text = this.$t('lang_LABEL_RELEASES_PANEL_CAPTION_COSTS') + ': ' + this.$t(element.text)
            })

            types.sort((a,b) => (a.text > b.text) ? 1 : (b.text > a.text) ? -1 : 0)

            return types
        },
        countryItems() { return this.$alvPlugin.getListOfTranslatedCountries() }
    },
    methods: {
        formatAmountBeforeSave(item) {
            item.amount = this.$alvPlugin.stringToFloat(item.amount)
            return item
        }
    },
}
</script>